import { render } from "./filter-and-sort.vue?vue&type=template&id=12171502"
import script from "./filter-and-sort.vue?vue&type=script&lang=js"
export * from "./filter-and-sort.vue?vue&type=script&lang=js"

import "./filter-and-sort.vue?vue&type=style&index=0&id=12171502&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__